import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';
const baseUrl = config.baseUrl;

const api = axios.create({
    baseURL: baseUrl,
    headers: {
        Authorization: `Bearer ${Cookies.get('token')}`,
        'Content-Type': 'application/json'
    }
});

export const getZonasInfluencia = async () => {
    try {
        const response = await api.get(
            '/api/zona-influencia'
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo zonas de influencia'
        };
    }
};

export const getTiposZonaInfluencia = async () => {
    try {
        const response = await api.get(
            '/api/zona-influencia/tipos'
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo tipos zona influencia'
        };
    }
};

export const getDepartamentos = async () => {
    try {
        const response = await api.get(
            '/api/zona-influencia/departamentos'
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo departamentos'
        };
    }
};

export const getMunicipios = async (
    oidDepartamento
) => {
    try {
        const response = await api.get(
            `/api/zona-influencia/municipios/${oidDepartamento}`
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo municipios'
        };
    }
};

export const createZonaInfluencia = async (
    payload
) => {
    try {
        const response = await api.post(
            '/api/zona-influencia',
            payload
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message:
                error.response?.data?.message ||
                'Error creando zona influencia'
        };
    }
};